import { Component, Listen, Prop, State, h } from '@stencil/core';
import { getRandomUniqueItemsFromArray } from '../../../conversational-search-logic/utils/utils';
import { predefinedQuestionsSuggestions } from '../predefined-suggestions/predefined-suggestions';
import { ConversationalSearchNewCovnersationFollowup } from '../new-conversation-followup/new-conversation-followup';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-conversational-search-message-new-conversation',
  styleUrl: 'new-conversation.scss',
  shadow: true,
})
export class WidgetConversationalSearchMessageNewConversation {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly query: string;

  @State() uniqueRandomItems: string[];

  @Listen('conversational-search:user-new-conversation', { target: 'window' })
  handleNewConversation() {
      this.handleUniqueSuggestions();
  }

  private handleUniqueSuggestions() {
      const predefinedSuggestionsWithLabels = predefinedQuestionsSuggestions(
        this.labelProvider
      );

      this.uniqueRandomItems = getRandomUniqueItemsFromArray(
        predefinedSuggestionsWithLabels,
        4
      );
  }

  connectedCallback() {
      this.handleUniqueSuggestions();
  }

  render() {
      return (
        <div class="conversational-search-messages-new-conversation">
          <section class="conversational-search-messages-new-conversation__header">
            <div>
              <strong>
                {this.labelProvider(
                  'conversational.search.name',
                  'GenAI Search',
                )}
              </strong>
            </div>
            <span>
              {this.labelProvider(
                'conversational.search.new.conversation.intro',
                'Please specify your product question'
              )}
            </span>
          </section>
          <uiaas-search-widget-conversational-search-suggestion-tiles
            items={this.uniqueRandomItems}
            query={this.query}
          />
          <section class="conversational-search-messages-new-conversation__outro-message">
            <ConversationalSearchNewCovnersationFollowup labelProvider={(e, f) => this.labelProvider(e, f)} />
          </section>
        </div>
      );
  }
}
